module.exports = function() {
  return new Worker(__webpack_public_path__ + "91da7fa17e8f17fee2f5.worker.js");
};